import * as yup from 'yup'

const joinFormValidationSchema = yup
  .object({
    name: yup.string().required('Name is required').min(3, 'Name should contain at least ${min} characters'),
    password: yup
      .string()
      .required('Password is required')
      .min(8, 'Password should contain at least ${min} characters'),
    rePassword: yup
      .string()
      .required('Password confirmation is required')
      .oneOf([yup.ref('password')], `Password doesn't match`)
  })
  .required()

export default joinFormValidationSchema
